var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerLive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.498 15.375l4.5-3.375-4.5-3.375v6.75z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5A7.498 7.498 0 004.5 12c0 4.144 3.356 7.5 7.5 7.5s7.5-3.356 7.5-7.5-3.356-7.5-7.5-7.5zM12 18c-3.308 0-6-2.693-6-6 0-3.308 2.692-6 6-6 3.307 0 6 2.692 6 6 0 3.307-2.693 6-6 6z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 0a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3h18zM3 1.5A1.5 1.5 0 001.5 3v18A1.5 1.5 0 003 22.5h18a1.5 1.5 0 001.5-1.5V3A1.5 1.5 0 0021 1.5H3z",
    fill: "currentColor"
  })));
}
SvgPokerLive.displayName = 'PokerLive';
export default SvgPokerLive;